// const BASE_URL = "http://localhost:3000";
const BASE_URL = "/api";

export { BASE_URL };
